export default __webpack_public_path__ + "media/images/ico-telephone-e7ad22c3685d68c177e3d414b864d006.svg";